import { cn } from "@/utils/cn"
import { formatDistanceToNow, format, isValid } from "date-fns"

interface DateDisplayProps {
  date: Date | string
  format?: 'relative' | 'absolute' | 'both'
  showTime?: boolean
  className?: string
}

export const DateDisplay = ({
  date,
  format: dateFormat = 'relative',
  showTime = false,
  className
}: DateDisplayProps) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  
  if (!isValid(dateObj)) {
    return (
      <span className={cn("text-muted-foreground", className)}>
        Invalid date
      </span>
    )
  }

  const formatPattern = showTime ? 'MMM d, yyyy h:mm a' : 'MMM d, yyyy'
  const absoluteDate = format(dateObj, formatPattern)
  const relativeDate = formatDistanceToNow(dateObj, { addSuffix: true })

  if (dateFormat === 'absolute') {
    return (
      <span className={cn("text-sm", className)} title={relativeDate}>
        {absoluteDate}
      </span>
    )
  }

  if (dateFormat === 'both') {
    return (
      <div className={cn("space-y-1", className)}>
        <div className="text-sm font-medium">{relativeDate}</div>
        <div className="text-xs text-muted-foreground">{absoluteDate}</div>
      </div>
    )
  }

  // Default: relative
  return (
    <span className={cn("text-sm", className)} title={absoluteDate}>
      {relativeDate}
    </span>
  )
}